/** Arkib perancangan pengendali pusat dalam Tetapan → Penyewa, sebelum pembersihan (Fasa 2 P2-5). */
export default {
  archive: {
    title: 'Arkib kes perancangan',
    intro:
      'Pembersihan memadam setiap kes perancangan, sejarahnya dan failnya. Cipta pakej arkib bagi setiap kes, muat turun pakej itu bersama kunci awam, dan serahkan kepada pelanggan terlebih dahulu.',
    none: 'Penyewa ini tiada kes perancangan.',
    loading: 'Membaca kes perancangan…',
    loadFailed: 'Kes perancangan tidak dapat dibaca.',
    retryLoad: 'Cuba lagi',
    counts: '{{archived}} daripada {{cases}} kes mempunyai pakej arkib semasa.',
    liveJobs:
      'Pakej sedang dibina: {{exports}}. Semakan lukisan sedang berjalan: {{intakes}}. Import pakej sedang berjalan: {{imports}}. Surat sedang dijana: {{letters}}. Tugas menunggu pekerja: {{queued}}.',
    create: 'Cipta pakej arkib',
    retryFailed: 'Cuba semula yang gagal',
    stop: 'Henti',
    working: 'Mencipta pakej arkib…',
    gapsTitle: 'Kes tanpa pakej arkib semasa',
    gapsMore: '{{count}} lagi tidak disenaraikan.',
    reasons: {
      no_archive: 'Belum ada pakej arkib',
      stale: 'Pakej lebih lama daripada perubahan terkini',
      running: 'Sedang dibina',
      failed: 'Pakej tidak dapat dibina',
      revoked: 'Dimeterai dengan kunci yang dibatalkan: akan dibina semula',
      chain_broken: 'Sejarah gagal disahkan: tiada pakej boleh dibina',
    },
    packagesTitle: 'Pakej arkib',
    packageLine: 'Hingga peristiwa {{seq}}',
    download: 'Muat turun',
    downloadLabel: 'Muat turun pakej arkib {{caseRef}}',
    downloadFailed: 'Pakej tidak dapat dimuat turun.',
    more: 'Tunjukkan lebih banyak pakej',
    jwks: 'Muat turun kunci awam (JWKS)',
    jwksHint:
      'Pembersihan memusnahkan kunci tandatangan. Tanpa fail ini tiada sesiapa boleh menyemak pakej selepas itu.',
    delivered: 'Saya telah menyerahkan pakej arkib dan kunci awam kepada pelanggan.',
    waiver: 'Bersihkan tanpa pakej bagi kesemua {{total}} kes yang tiada pakej arkib semasa',
    waiverHint:
      'Gunakan hanya apabila sesuatu kes tidak boleh diarkibkan, atau apabila pelanggan telah mengarahkannya secara bertulis. Log audit merekodkannya.',
    waiverReason: 'Sebab',
    waiverReasons: {
      unarchivable: 'Kes tidak boleh diarkibkan',
      controller_instruction: 'Pelanggan mengarahkannya',
    },
    blocked: {
      jobs_running: 'Tunggu sehingga pakej yang sedang dibina, semakan lukisan dan import pakej selesai.',
      unarchived: 'Setiap kes memerlukan pakej arkib semasa, atau pengecualian di bawah.',
      not_confirmed: 'Sahkan bahawa pakej arkib telah diserahkan.',
    },
    refusal: {
      planning_jobs_running:
        'Pembersihan ditolak: {{exports}} pakej, {{intakes}} semakan lukisan, {{imports}} import pakej dan {{letters}} penjanaan surat masih berjalan, dan {{queued}} tugas menunggu pekerja.',
      planning_cases_unarchived: 'Pembersihan ditolak: {{total}} kes tiada pakej arkib semasa.',
      planning_archives_not_confirmed: 'Pembersihan ditolak: sahkan bahawa {{archived}} pakej arkib telah diserahkan.',
      planning_register_unreachable:
        'Pembersihan ditolak: pelayan daftar perancangan {{host}} ({{database}}) tidak menjawab, jadi baris penyewa ini padanya tidak dapat dipadam. Baiki sambungan, atau bersihkan tanpa memadamnya.',
    },
    registerSkip:
      'Bersihkan tanpa memadam baris penyewa ini pada pelayan daftar tersebut. Baris itu kekal di situ; log audit merekodkannya.',
    incomplete:
      'Data penyewa telah dipadam, tetapi sebahagian fail perancangan masih ada. Jalankan pembersihan sekali lagi untuk menyelesaikannya.',
  },
}
